import  * as $ from 'jquery/dist/jquery.min.js'

window.jQuery = window.$ = $
